import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { departmentAction, packageAction } from '../../redux/action';
import { ROUTE } from '../../route/Route';
import Modal from 'react-modal';
import BreadCrumb from '../breadcrumb/BreadCrumb';
import ImgPlaceHolder from '../../constant/imgPlaceholder';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from '../../redux/common/common-reducer';
import SeoAdd from '../Seo/SeoAdd';
import WaitScreen from '../LodingScreen/WaitScreen';
import { useTranslation } from "react-i18next";
import SectionLoader from '../LodingScreen/SectionLoader';
import { replaceImgUriByLang } from '../../constant/utils';

function Offer() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const [offerId, setOfferId] = useState("");
    const [imgUri, setImgUri] = useState<string>("");
    const [offer, setOffer] = useState<any>({});
    const [selectedOffer, setSelectedOffer] = useState<any>("");
    const offerData = useSelector((state: any) => state.package.offer);

    useEffect(() => {
        window?.scrollTo(0, 0);
        dispatch(packageAction.getAllOfferAction({}));
        return () => { };
    }, []);

    useEffect(() => {
        if (offerData) {
            setImgUri(offerData?.CouponBannerBaseUrl);
            setOffer(offerData?.Coupons);
        }
        return () => { };
    }, [offerData]);

    useEffect(() => {
        if (offerId) {
            dispatch(packageAction.getAllOfferByIdAction({}));
        }
        return () => { };
    }, [offerId]);

    const [modalIsOpen, setModalIsOpen] = useState(false);

    const setModalIsOpenToTrue = (data: any) => {
        setSelectedOffer(data);
        setModalIsOpen(true)
    }

    const setModalIsOpenToFalse = () => {
        setModalIsOpen(false)
    }
    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: '#fff',
            maxWidth: '800px',
        }
    };
    const onCopy = () => {
        dispatch(toast({ message: "Coupon Code Copied Successfully", type: 'success' }));
    }
    const handleCheckout = (e: any) => {
        e.preventDefault();
        history.push(ROUTE.CHECKOUT, { type: "", data: {} });
    }
    return (
        <>
            <SeoAdd slug={ROUTE.OFFER} />
            <Modal isOpen={modalIsOpen} style={customStyles} onRequestClose={() => setModalIsOpen(false)}>
                <div className="model-header">
                    <span className="model-btn pointer" onClick={setModalIsOpenToFalse}>x</span>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <h5 className="infobox_title text-uppercase">{selectedOffer?.CouponTitle}</h5>
                        <div className="pl-1">{selectedOffer?.ShortDescription && selectedOffer?.ShortDescription.slice(0, 100)}</div>
                        <div className="p-3">
                            <div dangerouslySetInnerHTML={{ __html: selectedOffer?.Description && selectedOffer?.Description.slice(0, 500) }}></div>
                            <a href="#" className="button--hexagon1" onClick={(e: any) => handleCheckout(e)}><span><i className="fa fa-file-image-o mr-20" aria-hidden="true"></i>{t("book_now")}</span></a>
                            {/* <CopyToClipboard text={selectedOffer?.CouponCode} onCopy={onCopy}><a href="#" onClick={(e:any)=>e.preventDefault()} className="button--hexagon1 ml-3"><span><i className="fa fa-file-image-o mr-20" aria-hidden="true"></i>COPY</span></a></CopyToClipboard> */}
                        </div>
                    </div>
                </div>
            </Modal>
            <BreadCrumb page={t("bread_all_offer")} data={{ slug: "", path: "" }} />
            <section className="sub-section h-offers bg-color">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="headingmains text-center pb-3">
                                <h1 className="right aos-init pb-2">{t("all_offer")}</h1>
                                <div className='row'>
                                    <div className='col-lg-2 col-sm-1'></div>
                                    <div className='col-lg-8 col-sm-10'>
                                        <p className="text-center pl-2 pr-2">
                                            {t("offer_content")}
                                        </p>
                                    </div>
                                    <div className='col-lg-2 col-sm-1'></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row offer-slider">
                        {offerData && Object.keys(offerData).length > 0 ?
                            <>
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    {offer && offer?.length > 0 && offer?.map((item: any, i: any) => i < 2 &&
                                        (
                                            <div className="h-off sbg1" onClick={() => setModalIsOpenToTrue(item)}>
                                                <img src={item?.CouponIcon ? replaceImgUriByLang(item?.CouponIcon) : "/assets/img/offer0" + (i + 1) + ".png"} onError={(e: any) => ImgPlaceHolder(e, item?.CouponIcon || ("/assets/img/offer0" + (i + 1) + ".png"))} className="scale" alt="" />
                                            </div>
                                        ))}
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <div className="btnoffer-d offer_below">
                                    </div>
                                    {offer && offer?.length > 0 && offer?.map((item: any, i: any) => i >= 2 && i < 4 &&
                                        (
                                            <div className="h-off sbg1" onClick={() => setModalIsOpenToTrue(item)}>
                                                <img src={item?.CouponIcon ? replaceImgUriByLang(item?.CouponIcon) : "/assets/img/offer0" + (i + 1) + ".png"} onError={(e: any) => ImgPlaceHolder(e, item?.CouponIcon || ("/assets/img/offer0" + (i + 1) + ".png"))} className="scale" alt="" />
                                            </div>
                                        ))}
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    {offer && offer?.length > 0 && offer?.map((item: any, i: any) => i >= 4 && i < 6 &&
                                        (
                                            <div className="h-off sbg1" onClick={() => setModalIsOpenToTrue(item)}>
                                                <img src={item?.CouponIcon ? replaceImgUriByLang(item?.CouponIcon) : "/assets/img/offer0" + (i + 1) + ".png"} onError={(e: any) => ImgPlaceHolder(e, item?.CouponIcon || ("/assets/img/offer0" + (i + 1) + ".png"))} className="scale" alt="" />
                                            </div>
                                        ))}
                                </div>
                            </>
                            :
                            <SectionLoader/>
                        }
                    </div>
                </div>
            </section>
        </>
    )
}

export default Offer
